import { FC, useCallback, useEffect, useMemo, useRef } from 'react'
import { AgGridReact } from 'ag-grid-react'
import { } from '@ag-grid-community/core'
import { ColDef, ColGroupDef, ServerSideStoreType } from 'ag-grid-community'
import { useBetween } from 'use-between'
import { BTGlobal } from '../BTglobal/BTGlobal'
import { AG_GRID_LOCALE_ES } from './locale.es'
import { AllCommunityModules } from '@ag-grid-community/all-modules';

const AgGridTable: FC<AgGridTableProps> = (props) => {
  const { setBtGridRef } = useBetween(BTGlobal)
  const gridRef = useRef<any>(null)
  const gridStyle = useMemo(() => ({ height: '60vh', width: '100%' }), [])
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), [])
  useEffect(() => {
    if (props.dataRow !== undefined && props.setAGGridRef) {
      if (props.dataRow.length > 0) {
        setTimeout(() => {
          props.setAGGridRef(gridRef)
        }, 500)
      }
    }
  }, [props.isRefreshGrid])

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      minWidth: 100,
      sortable: true,
      filter: true,
      resizable: true,
      editable: false,
    }
  }, [])

  if (props.isRefreshGrid === true) {
    setTimeout(() => {
      setBtGridRef(gridRef)
    }, 300)
  }

  try {
    props.setAGGridRef(gridRef)
  } catch (error) { }

  const onCellClicked = useCallback((event: any) => {
    setBtGridRef(gridRef)
    const selectedRows = gridRef.current.api.getSelectedRows()
    return props.onClick ? props.onClick(selectedRows, gridRef, event) : undefined
  }, [])

  const onChange = useCallback((event: any) => {
    setBtGridRef(gridRef)
    const selectedRows = gridRef.current.api.getSelectedRows()
    return props.onChange ? props.onChange(selectedRows, gridRef, event) : undefined
  }, [])

  const localeText = useMemo(() => {
    return AG_GRID_LOCALE_ES;
  }, [])

  return (
    <div style={containerStyle}>
      <div
        style={props.style || gridStyle}
        className={`ag-theme-alpine popup_minuta border-0 table-contract step2-ag-grid1 ${props.className || ''}`}
      >
        <AgGridReact
          ref={gridRef}
          columnDefs={props.columnDefs}
          defaultColDef={defaultColDef}
          rowHeight={props.rowHeight || 90}
          enableCellChangeFlash={false}
          rowSelection={props.rowSelection ? props.rowSelection : 'single'}
          onRowClicked={onCellClicked}
          rowData={props.dataRow}
          rowDragManaged={true}
          onRowDragEnd={props.onRowDrag}
          pinnedTopRowData={props.rowPinned}
          onGridReady={props.onGridReady}
          serverSideStoreType={props.serverSideStoreType}
          pagination={props.pagination}
          paginationPageSize={props.paginationPageSize}
          onCellClicked={onCellClicked}
          rowClassRules={props.rowClassRules}
          getRowStyle={props.getRowStyle}
          onSelectionChanged={onChange}
          onCellValueChanged={props.onCellValueChanged}
          suppressRowClickSelection={props.suppressRowClickSelection}
          suppressRowDeselection={props.suppressRowDeselection}
          rowMultiSelectWithClick={props.rowMultiSelectWithClick}
          localeText={localeText}
          onFirstDataRendered={props.onFirstDataRendered}
        ></AgGridReact>
      </div>
    </div>
  )
}
AgGridTable.defaultProps = {
  pagination: true,
  paginationPageSize: 10,
  rowDrag: false,
  rowHeight: 90,
}
interface AgGridTableProps {
  columnDefs?: (ColDef | ColGroupDef)[] | undefined
  style?: React.CSSProperties | undefined
  className?: string | undefined
  defaultColDef?: any
  dataRow?: any
  rowDrag?: boolean
  rowHeight?: number
  rowPinned?: any
  rowClassRules?: any
  serverSideStoreType?: ServerSideStoreType
  pagination?: boolean
  paginationPageSize?: number
  setAGGridRef?: any
  cacheBlockSize?: number
  animateRows?: boolean
  onGridReady?: any
  onFirstDataRendered?(params: any): void | undefined
  getRowStyle?(params : any): any | undefined
  onRowDrag?(e: any): void | undefined
  onClick?(row: any, dataGrid: React.MutableRefObject<any>, event: any): void | undefined
  onChange?(row: any, dataGrid: React.MutableRefObject<any>, event: any): void | undefined
  onCellValueChanged?(params: any): void
  isRefreshGrid?: boolean
  suppressRowClickSelection?: boolean
  suppressRowDeselection?: boolean
  rowMultiSelectWithClick?: boolean
  rowSelection?: string
}
export interface columnDefsProps {
  field?: string
  headerName?: string
  minWidth?: string
  editable?: boolean
  cellEditorParams?: any
  cellRenderer?: void
}
export { AgGridTable }
